import createAxios from './axiosHttp';

function getPurchase(pagination,filters) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/purchase`;
    if (pagination) {
        urlPath += `?page=${pagination.currentPage - 1}&limit=${pagination.rows}`;
    } else {
        urlPath += '?page=0&limit=20';
    }
    if (filters && filters.search) {
        urlPath += `&search=${encodeURIComponent(filters.search)}`;
    }
    if (filters && filters.status) {
        urlPath += `&status=${filters.status}`;
    }
    if (filters && filters.sort) {
        if(filters.sort.sort){
            urlPath += `&sort=${filters.sort.sort}`;
        }
        if(filters.sort.order){
            urlPath += `&order=${filters.sort.order}`;
        }
    }
    if (filters && filters.date.start) {
        urlPath += `&start_date=${filters.date.start}`
    }
    if (filters && filters.date.end) {
        urlPath += `&end_date=${filters.date.end}`
    }
    if (filters && filters.sga_registered) {
        urlPath += `&sga_registered=${filters.sga_registered}`
    }
    return axios.get(urlPath);
}
function getPurchaseById(id){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/purchase/${id}`;
    return axios.get(urlPath);
}
function getPurchasesAsExcel(filters, language) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/purchase/${language}/report`;
    urlPath += `?page=0&limit=1000000`;
    if (filters && filters.search) {
        urlPath += `&search=${encodeURIComponent(filters.search)}`;
    }
    if (filters && filters.status) {
        urlPath += `&status=${filters.status}`;
    }
    if (filters && filters.date.start) {
        urlPath += `&start_date=${filters.date.start}`
    }
    if (filters && filters.date.end) {
        urlPath += `&end_date=${filters.date.end}`
    }
    if (filters && filters.sga_registered) {
        urlPath += `&sga_registered=${filters.sga_registered}`
    }
    return axios.get(urlPath, {
        responseType: 'blob'
    });
}
function getTracking(puechaseId) {
    const axios = createAxios();
    let urlPath = `purchase/${puechaseId}/tracking`;
    return axios.get(urlPath);
}

function getResources(purchaseId) {
    const axios = createAxios();
    const user = JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/purchase/${purchaseId}/resources`;
    return axios.get(urlPath);
}

function downloadResource(purchaseId, fileName){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/purchase/${purchaseId}/resources?filename=${fileName}`;
    return axios.get(urlPath, {
        responseType: 'blob'
    });
}

function onHoldStatus(body, entityId){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/purchase/${entityId}/onHold`;
    return axios.put(urlPath, body);
}

function cancel(entityId) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/purchase/${entityId}`;
    return axios.delete(urlPath);
}

function recover(entityId) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/purchase/${entityId}/recover`;
    return axios.put(urlPath);
}

export const purchaseService = { getPurchase,getPurchaseById,getPurchasesAsExcel,getTracking, getResources, downloadResource, onHoldStatus, cancel, recover };